/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { updateSpotFiltersV2 } from "../../slices/spotFiltersSlice";

import Select from "../common/Select";
import types from "../../helpers/types";
import { isCarrier } from "../../helpers/goTrackUserUtils";

const SpotStatusFilter = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const status = useSelector((state) => {
    return state.spotFilters.status;
  });

  const user = useSelector((state) => state.goTrackUser.goTrackUser);

  const handleChange = ({ target: { value } }) => {
    dispatch(
      updateSpotFiltersV2({
        filters: { status: value },
        history,
      })
    );
  };

  return (
    <>
      {isCarrier(user.roles) && (
        <Select
          selectedValue={status}
          width={245}
          label="Leg Status"
          inputId="spot-status-filter"
          data-testid="carrier-status-filter"
          handleChange={handleChange}
          options={types.carrierSpotLegStatusWithCreationType}
        />
      )}
      {!isCarrier(user.roles) && (
        <Select
          selectedValue={status}
          width={245}
          label="Leg Status"
          inputId="spot-status-filter"
          data-testid="ups-user-status-filter"
          handleChange={handleChange}
          options={types.spotLegStatusWithCreationType}
        />
      )}
    </>
  );
};

export default SpotStatusFilter;
